import { Money, ProductConditionCode } from "../../../common/models/CommonModels";
import { FileModel, Page, QueryBase, WarrantyTypeCode } from "../../../shared/models/models";
import { ProductAvailabilityCode } from "../../inventory/models/models";
import { Rfq } from "../../myRfqs/models/models";
import { CustomerReference } from "../../rfqFeed/models/models";

export interface CustomerBuyerOffersState {
  query: OffersQuery;
  offers?: Page<Offer>;
  offer?: Offer;
  rfq?: Rfq;
  manufacturers: ManufacturerReference[],
  categories: CategoryReference[],
  loading: boolean;
  success?: string;
  error: any;
}

export interface Offer {
  id: string;
  createdDate: Date;
  quotationRequestId: string;
  quotationRequestCreatedDate: string;
  quotationRequestNumber: string;
  supplierId: string;
  stockItemId: string;
  productNumber: string;
  productAlternativeNumber: string;
  availabilityCode: ProductAvailabilityCode;
  productConditionCode: ProductConditionCode;
  description: string;
  unitPrice: Money;
  quantity?: number;
  warrantyPeriodMonths?: number;
  isPriceBoundToDocument: boolean,
  statusCode: OfferStatusCode;
  supplier: CustomerReference;
  manufacturer: ManufacturerReference;
  category: CategoryReference;
  documentFile: FileModel;
  imageFile: FileModel;
}

export interface ChangeOffer {
  quotationRequestId: string;
  stockItemId?: string;
  productNumber: string;
  productAlternativeNumber?: string;
  manufacturerId: string;
  categoryId: string;
  availabilityCode: ProductAvailabilityCode;
  productConditionCode: ProductConditionCode;
  description?: string;
  unitPrice?: Money;
  quantity?: number;
  warrantyPeriod?: WarrantyTypeCode;
  warrantyPeriodMonths?: number;
  documentFile: FileModel | null;
  imageFile: FileModel | null;
  isPriceBoundToDocument: boolean;
}

export interface ManufacturerReference {
  id: string;
  name: string;
}

export interface CategoryReference {
  id: string;
  name: string;
}

export enum OfferStatusCode {
  new = 1,
  seen = 2,
  accepted = 3,
  declined = 4,
  canceled = 5
}

export enum OffersQueryParameter {
  createdDate = 1,
  modifiedDate = 2
}

export interface OffersQuery extends QueryBase<OffersQueryParameter> {
  quotationRequestId?: string;
}

export const isOffersQueryEmpty = (query: OffersQuery): boolean => {
  return !query.search &&
    !query.quotationRequestId;
};
